import React, { useState } from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { InstagramWall } from './components/InstagramWall';
import { EventsPage } from './pages/EventsPage';
import { GalleryPage } from './pages/GalleryPage';
import { BottleServicePage } from './pages/BottleServicePage';
import { ReservationPage } from './pages/ReservationPage';
import { ContactPage } from './pages/ContactPage';
import { SeatingOptions } from './components/SeatingOptions';
import { FloorMap } from './components/FloorMap';
import { Footer } from './components/Footer';
export type Page = 'home' | 'events' | 'gallery' | 'bottle-service' | 'reservation' | 'contact';
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const goHome = () => {
    setCurrentPage('home');
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const goPage = (page: Page) => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen w-full bg-[#050505] overflow-x-hidden" data-id="element-0">
      <Navigation currentPage={currentPage} setCurrentPage={goPage} data-id="element-1" />
      <main data-id="element-2">
        {currentPage === 'home' && <>
            <Hero data-id="element-3" />
            <InstagramWall data-id="element-4" />
            <SeatingOptions data-id="element-5" />
            <FloorMap data-id="element-6" />
          </>}
        {currentPage === 'events' && <EventsPage onBack={goHome} data-id="element-7" />}
        {currentPage === 'gallery' && <GalleryPage onBack={goHome} data-id="element-8" />}
        {currentPage === 'bottle-service' && <BottleServicePage onBack={goHome} onReserve={() => goPage('reservation')} data-id="element-9" />}
        {currentPage === 'reservation' && <ReservationPage onBack={goHome} data-id="element-10" />}
        {currentPage === 'contact' && <ContactPage onBack={goHome} data-id="element-11" />}
      </main>
      <Footer data-id="element-12" />
    </div>;
}